import React from "react";
import "./footer.scss";
// import { Row, Col } from "reactstrap";

function Footer() {
  return (
    <div className="footer-container">
      <div className="logo-section">
        <img
          className="logo"
          src={require("../../../assets/images/icons/logo-gray.svg")}
          alt=""
        />
        <div className="social-containerr">
          <a
            href="https://youtube.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={require("../../../assets/images/icons/social/y.png")}
              alt=""
            />
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={require("../../../assets/images/icons/social/t.png")}
              alt=""
            />
          </a>
          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={require("../../../assets/images/icons/social/l.png")}
              alt=""
            />
          </a>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={require("../../../assets/images/icons/social/i.png")}
              alt=""
            />
          </a>
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={require("../../../assets/images/icons/social/f.png")}
              alt=""
            />
          </a>
        </div>
      </div>
      <div className="contact-section">
        <p className="address opacity-80">
          308-309 Tower C, Unitech Business Zone, Sector 50 <br />
          Golf Course Extension Road, Gurugram, Haryana 122002
        </p>
        <div className={"email-phone-container"}>
          <div className="phone-div">
            <img
              src={require("../../../assets/images/icons/phone.svg")}
              alt=""
            />
            <h3 className="m-0">+91-9389-9389-38</h3>
          </div>
          <div className="email-div">
            <img
              src={require("../../../assets/images/icons/email.svg")}
              alt=""
            />
            <h3 className="m-0">hello@toffeeinsurance.com</h3>
          </div>
        </div>
      </div>
      <div className="gst-section">
        <h3 className="m-0">
          Corporate Agent (Composite) <br />
          Design For Use Consulting Pvt. Ltd.
          <br />
          IRDAI Registration Number: CA0524
          <br />
          Valid Till: 22OCT2020
          <br />
          CIN: U74140DL2007PTC157638
        </h3>
      </div>
    </div>
  );
}

export default Footer;
